export const locations = [
  {
    title: "Bástya Idősotthon",
    address: "4450 Tiszalök, Hősök tere 7/a",
    position: [48.02199, 21.38174],
  },
  {
    title: "Forrás Idősotthon",
    address: "4450 Tiszalök, Kossuth utca 41.",
    position: [48.02063, 21.37931],
  },
  {
    title: "Nappali ellátás",
    address: "4450 Tiszalök, Damjanich utca 24.",
    position: [48.01784, 21.37468],
  },
];
